
import React from "react";
import { PrayerTime } from "@/types/page";
import PrayerTimesPage from "@/components/pages/PrayerTimesPage";

interface PrayerTimesPreviewProps {
  prayerTimes: PrayerTime[];
  blockTitle: string;
  animationSpeed: number;
}

const PrayerTimesPreview: React.FC<PrayerTimesPreviewProps> = ({ prayerTimes, blockTitle, animationSpeed }) => {
  const previewContent = {
    blockTitle: blockTitle,
    sections: [
      {
        id: "prayer-times",
        title: blockTitle,
        prayerTimes: prayerTimes
      }
    ],
    animationSpeed: animationSpeed
  };

  return (
    <div className="w-full">
      <PrayerTimesPage content={previewContent} />
    </div>
  );
};

export default PrayerTimesPreview;
